import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Player } from '@lottiefiles/react-lottie-player';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faQuestionCircle,
  faShieldAlt,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import loader from '../../loader/main_loading_animation.json'


const SubscriptionCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    
      
      <div className="bg-white rounded-xl shadow-md overflow-hidden mb-12">
        <div className="bg-gradient-to-r from-[#0e4621]/10 to-white p-8 md:p-12">
          <div className="max-w-3xl mx-auto text-center">
            <div className="h-32 w-32 mx-auto mb-6">
              <Player
                src={loader || {}}
                className="player"
                loop={false}
                autoplay
                keepLastFrame
              />
            </div>
            
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Checkout Canceled
            </h1>
            
            <p className="text-xl text-gray-600 mb-8">
              Your subscription checkout was canceled and no charges were made.
              You can try again whenever you're ready.
            </p>
            
            <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
              <button 
                onClick={() => navigate('/subscription/checkout')} 
                className="px-6 py-3 bg-[#0e4621] text-white rounded-full hover:bg-[#0a3419] transition-colors font-medium flex items-center justify-center"
              >
                <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
                Return to Checkout
              </button>
              
              <button 
                onClick={() => navigate('/')} 
                className="px-6 py-3 bg-gray-100 text-gray-800 rounded-full hover:bg-gray-200 transition-colors font-medium flex items-center justify-center"
              >
                Continue Browsing
                <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
              </button>
            </div>
          </div>
        </div>
      </div>
      
      {/* Common Questions */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold text-[#0e4621] mb-6 flex items-center">
          <span className="w-8 h-1 bg-[#DAA520] block mr-3"></span>
          Common Questions
        </h2>
        
        <div className="bg-white rounded-xl shadow-sm p-6 md:p-8">
          <div className="grid md:grid-cols-2 gap-6">
            <div className="border-b md:border-b-0 md:border-r border-gray-100 pb-6 md:pb-0 md:pr-6">
              <div className="flex items-start mb-4">
                <FontAwesomeIcon icon={faQuestionCircle} className="h-5 w-5 text-[#0e4621] mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold text-gray-800 mb-2">Why was my checkout canceled?</h3>
                  <p className="text-gray-600">
                    You might have clicked the back button, closed the window, or there could have been 
                    an issue with the payment information. No charges were made to your account.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start">
                <FontAwesomeIcon icon={faQuestionCircle} className="h-5 w-5 text-[#0e4621] mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold text-gray-800 mb-2">Can I still use Ladle?</h3>
                  <p className="text-gray-600">
                    Yes! You can continue using Ladle with the standard features. You can upgrade 
                    to premium anytime to unlock all premium features.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="pt-6 md:pt-0 md:pl-6">
              <div className="flex items-start mb-4">
                <FontAwesomeIcon icon={faQuestionCircle} className="h-5 w-5 text-[#0e4621] mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold text-gray-800 mb-2">Will I be charged anything?</h3>
                  <p className="text-gray-600">
                    No. Since you didn't complete the checkout process, no charges will appear 
                    on your account.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start">
                <FontAwesomeIcon icon={faQuestionCircle} className="h-5 w-5 text-[#0e4621] mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold text-gray-800 mb-2">How do I try again?</h3>
                  <p className="text-gray-600">
                    You can return to the subscription page anytime to select a plan and 
                    complete the checkout process.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom CTA */}
      <div className="bg-gradient-to-r from-[#0e4621] to-[#0a3419] rounded-xl p-8 text-white shadow-lg">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="mb-6 md:mb-0 md:mr-8">
            <div className="flex items-center mb-4">
              <FontAwesomeIcon icon={faShieldAlt} className="h-8 w-8 text-[#DAA520]" />
              <h2 className="text-2xl font-bold ml-3">Ready When You Are</h2>
            </div>
            <p className="text-white/80">
              Our premium features will be waiting for you whenever you're ready to enhance your 
              cooking experience.
            </p>
          </div>
          <button 
            onClick={() => navigate('/subscription/checkout')}
            className="px-6 py-3 bg-[#DAA520] text-white rounded-full hover:bg-[#c19419] transition-colors shadow-md font-medium whitespace-nowrap"
          >
            View Plans Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancelPage;
